import { Dispatch } from 'redux'
import {
  getNotesByContract,
  editNote,
  addNote,
  setNull,
  deleteNote,
} from 'app/state/ducks/notes/actions'
import config from 'app/config/config'
import { client } from 'app/shared/api/client'
import { ContractType } from 'app/models/common-types'
import { Note } from 'app/models/note-params'
import { coalesceThunkByKey } from 'app/state/utils/coalesce-thunk'

export const saveNote = (note: Note) => async (dispatch: Dispatch) => {
  const apiServerUrl = config.backendUrl
  const endpoint = `${apiServerUrl}/api/notes`

  try {
    const body = {
      ...note,
      title: note.title ?? null,
      tags: note.tags ?? [],
    }
    const response = await client.post(endpoint, body)
    dispatch(addNote(response.data))
    return { success: true, payload: response.data }
  } catch (error) {
    console.error('THUNK ERROR', error)
    return { success: false, payload: error }
  }
}

export const readNoteByContract = async (id: string, type: ContractType) => {
  const apiServerUrl = config.backendUrl
  try {
    const data = await client.get(
      `${apiServerUrl}/api/notes/${type}/${id}`,
    )
    return data.data
  } catch (error) {
    console.log('THUNK ERROR', error)
  }
}

export const loadNotesByContract = coalesceThunkByKey(
  (id: string, type: ContractType) => async (dispatch: Dispatch) => {
    const apiServerUrl = config.backendUrl
    try {
      // Clear existing notes for this contract type before fetching new ones
      dispatch(setNull({ contractType: type }))

      const data = await client.get(
        `${apiServerUrl}/api/notes/${type}/${id}`,
      )
      if (!data.data) {
        // If no notes are returned, keep it cleared (already done by setNull)
        return
      }
      return dispatch(getNotesByContract(data.data))
    } catch (error) {
      console.log('THUNK ERROR', error)
      dispatch(setNull({ contractType: type }))
    }
  },
)

export const updateNote =
  (
    id: string,
    newText: string | null,
    newTags?: string[],
    newTitle?: string | null,
  ) =>
  async (dispatch: Dispatch) => {
    const apiServerUrl = config.backendUrl
    try {
      const data = await client.put(`${apiServerUrl}/api/notes`, {
        id,
        newText,
        newTags: newTags ?? [],
        newTitle: newTitle ?? null,
      })
      dispatch(editNote(data.data))
      return { success: true, payload: data.data }
    } catch (error) {
      console.log('THUNK ERROR', error)
      return { success: false, payload: error }
    }
  }

export const deleteNoteById =
  (noteId: string) => async (dispatch: Dispatch) => {
    const apiServerUrl = config.backendUrl
    const endpoint = `${apiServerUrl}/api/notes`

    try {
      const response = await client.delete(endpoint, {
        params: { ids: [noteId] },
      })
      dispatch(deleteNote(response.data))
      return { success: true, payload: response.data }
    } catch (error) {
      console.error('THUNK ERROR', error)
      return { success: false, payload: error }
    }
  }
